class CartRemoveButton extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            cartItems.updateLine(this.dataset.index, 0);
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        this.lineItemStatusElement =
            document.getElementById('shopping-cart-line-item-status') ||
            document.getElementById('CartDrawer-LineItemStatus');

        const debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('manual-change', (event) => {
            debouncedOnChange(event);
        });

        this.addEventListener('change', (event) => {
            if (event.target.classList.contains('quantity-input--manual')) return;
            debouncedOnChange(event);
        });
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.cartUpdateUnsubscriber = addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') {
                return;
            }
            this.onCartUpdate();
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    onChange(event) {
        const cart_item = this.querySelectorAll(
            `#CartItem-${event.target.dataset.index}, #CartDrawer-Item-${event.target.dataset.index}`
        )[0];
        const cart_item_quantity = cart_item.querySelector(`[data-quantity-variant-id]`).value;
        if (cart_item.tagName === 'DIV' && cart_item_quantity === '') return;
        this.updateLine(
            event.target.dataset.index,
            cart_item_quantity,
            document.activeElement.getAttribute('name'),
            event.target.dataset.quantityVariantId
        );
    }

    onCartUpdate() {
        if (this.tagName === 'CART-DRAWER-ITEMS') {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                    for (const selector of selectors) {
                        const targetElement = document.querySelector(selector);
                        const sourceElement = html.querySelector(selector);
                        if (targetElement && sourceElement) {
                            targetElement.replaceWith(sourceElement);
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        } else {
            fetch(`${routes.cart_url}?section_id=main-cart-items`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const sourceQty = html.querySelector('cart-items');
                    this.innerHTML = sourceQty.innerHTML;
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'main-cart-header',
                section: document.getElementById('main-cart-header').dataset.id,
                selector: '.js-main-cart-header',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section',
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.cart__blocks',
            },
            {
                id: 'cart-sticky-add',
                section: document.getElementById('cart-sticky-add').dataset.id,
                selector: '.js-cart-add',
            },
        ];
    }

    getLineProperties(line) {
        let properties = {};
        const cart_item = this.querySelector(`#CartItem-${line}`) || this.querySelector(`#CartDrawer-Item-${line}`);
        if (!cart_item) return;
        const cart_item_properties = cart_item.querySelectorAll('[name^="properties"]');

        const getValue = (cart_item_property) => {
            return cart_item_property.value;
        };

        cart_item_properties.forEach((cart_item_property) => {
            const cart_item_property_name = cart_item_property
                .getAttribute('name')
                .split('properties[')[1]
                .split(']')[0];
            return (properties[cart_item_property_name] = getValue(cart_item_property));
        });

        return Object.keys(properties).length > 0 ? properties : undefined;
    }

    updateLine(line, quantity, name, variantId) {
        this.enableLoading(line);
        const cart_item = this.querySelectorAll(`#CartItem-${line}, #CartDrawer-Item-${line}`)[0];
        const cart_item_data = cart_item.dataset;
        const body = JSON.stringify({
            line: parseInt(line),
            quantity: parseInt(quantity),
            properties: this.getLineProperties(line),
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                const quantityElement =
                    document.getElementById(`Cart-quantity-${line}`) ||
                    document.getElementById(`Drawer-quantity-${line}`);
                const items = document.querySelectorAll('.cart-item');

                if (parsedState.errors) {
                    quantityElement.value = quantityElement.getAttribute('value');
                    this.updateLiveRegions(line, parsedState.errors);
                    return;
                }

                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartPage = document.getElementById('main-cart-page');

                if (cartPage) cartPage.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) ||
                        document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );
                });
                const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                let message = '';
                if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                    if (typeof updatedValue === 'undefined') {
                        message = window.cartStrings.error;
                    } else {
                        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                    }
                }
                this.updateLiveRegions(line, message);

                const lineItem =
                    document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(
                        cartDrawerWrapper.querySelector('.drawer__inner-empty'),
                        cartDrawerWrapper.querySelector('a')
                    );
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
                }

                sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cartUpdate, {
                    source: 'cart-items',
                    cartData: parsedState,
                    variantId: variantId,
                });
                if (quantity === 0) {
                    const response = JSON.parse(state);
                    const adjustedData = response.items_removed.map((item) => {
                        return {
                            ...item,
                            id: item.variant_id,
                            category: cart_item_data.analyticsCategory,
                        };
                    });
                    sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cart, {
                        event: 'remove_from_cart',
                        products: adjustedData,
                    });
                } else {
                    const response = JSON.parse(state);
                    if (response.items_removed.length > 0) {
                        const adjustedData = response.items_removed.map((item) => {
                            return {
                                ...item,
                                id: item.variant_id,
                                category: cart_item_data.analyticsCategory,
                            };
                        });
                        sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cart, {
                            event: 'remove_from_cart',
                            products: adjustedData,
                        });
                    } else if (response.items_added.length > 0) {
                        const adjustedData = response.items_added.map((item) => {
                            return {
                                ...item,
                                id: item.variant_id,
                                category: cart_item_data.analyticsCategory,
                            };
                        });
                        sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cart, {
                            event: 'add_to_cart',
                            products: adjustedData,
                        });
                    }
                }
            })
            .catch((response) => {
                this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
                const errors =
                    document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                errors.textContent = window.cartStrings.error;
            })
            .finally(() => {
                this.disableLoading(line);
            });
    }

    updateLiveRegions(line, message) {
        const lineItemError = document.querySelectorAll(`#Line-item-error-${line}, #CartDrawer-LineItemError-${line}`);
        if (lineItemError.length > 0)
            lineItemError.forEach((error) => (error.querySelector('.cart-item__error-text').innerHTML = message));

        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus =
            document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems =
            document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
        const mainCartItems =
            document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

        cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
}

customElements.define('cart-items', CartItems);

class StickyCheckout extends HTMLElement {
    constructor() {
        super();

        window.addEventListener('resize', debounce(this.toggleSticky.bind(this), 500));
        this.toggleSticky();
    }

    toggleSticky() {
        if (window.innerWidth < 769) {
            this.classList.add('fixed-checkout-button--active');
        } else {
            this.classList.remove('ixed-checkout-button--active');
        }
    }
}

customElements.define('sticky-checkout', StickyCheckout);

class CheckoutButton extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector('.js-button');
        this.message = this.querySelector('.js-message');

        this.button.addEventListener('click', this.goToCheckout.bind(this));

        // Check localStorage and call handleToggle if needed
        if (localStorage.getItem('precheck_terms') === 'true') {
            this.toggle.click();
        }
    }

    async goToCheckout(event) {
        event.preventDefault();
        this.hideError();
        if (this.button.dataset.customer !== 'true') {
            localStorage.setItem('precheck_terms', 'true');

            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('loginToCheckout', 'true');
            window.history.pushState({}, '', currentUrl);

            return document.querySelector('login-drawer').open();
        }

        window.velocityCartManager.goToCheckout();
    }

    // Optional: Add a method to show error messages
    showError(message) {
        if (this.message) {
            this.message.textContent = message;
            this.message.style.display = 'block';
            this.message.classList.remove('hidden');
            this.message.classList.add('global-message', 'global-message--error');
        }
    }

    hideError() {
        this.message.textContent = '';
        this.message.style.display = 'none';
        this.message.classList.add('hidden');
        this.message.classList.remove('global-message', 'global-message--error');
    }
}

customElements.define('checkout-button', CheckoutButton);
